interface CardProps {
  title: string
  description: string
}

export const CARD_DATA: CardProps[] = [
  {
    title: 'Master Your Pitch',
    description:
      'Command attention in seconds—craft a magnetic pitch that wins guests, sponsors, and partners over before you even finish the first sentence.',
  },
  {
    title: 'Craft Immersive Narratives',
    description:
      'Turn sound into story—use powerful writing and evocative audio design to transport listeners into your world and keep them coming back.',
  },
  {
    title: 'Lead Captivating Conversations',
    description:
      'Unlock the secrets of magnetic hosting—ask the questions that reveal deeper insights, spark authentic connections, and drive memorable dialogue.',
  },
  {
    title: 'Produce Flawless Audio',
    description:
      'From recording to final cut—streamline your workflow and polish every take so your podcast sounds crystal-clear, professional, and on brand.',
  },
  {
    title: 'Elevate Your Soundscape',
    description:
      'Transform your mix into an experience—blend music, effects, and voice into a cohesive sonic identity that amplifies your unique vision.',
  },
  {
    title: 'Amplify Your Reach',
    description:
      'Build a devoted audience—design a standout brand, craft compelling artwork, and launch data-driven campaigns that turn listeners into evangelists.',
  },
]
